/* Bordamar v11 · upsell sencillo en carrito: «otro igual» (descuento por volumen) + «combina con» */
(function () {
  'use strict';
  var cache = {};
  function fmt(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(u, w) { if (!u) return ''; if (typeof u === 'object') u = u.src || u.url || ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 160); }
  function short(t) { return (t || '').split(' — ')[0].split(' - ')[0]; }
  function nice(s) { return (s || '').toLowerCase().replace(/(^|\s|\/)\S/g, function (m) { return m.toUpperCase(); }); }
  function get(pid, intent) {
    return fetch('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=' + intent)
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (d) { return d.products || []; })
      .catch(function () { return []; });
  }
  function recs(pids) {
    var key = pids.slice(0, 2).join(',');
    if (cache[key]) return cache[key];
    var reqs = [get(pids[0], 'complementary'), get(pids[0], 'related')];
    if (pids[1]) reqs.push(get(pids[1], 'complementary'));
    cache[key] = Promise.all(reqs).then(function (a) {
      var seen = {}, out = [];
      a.forEach(function (list) { list.forEach(function (p) { if (seen[p.id] || !p.available) return; seen[p.id] = 1; out.push(p); }); });
      return out;
    });
    return cache[key];
  }
  function render(box, cart, list) {
    var n = cart.item_count, h = '', line = cart.items[0];
    if (line && n < 10) {
      var pct = n < 5 ? 5 : 10;
      h += '<div class="bm-ups__more">' +
        '<p class="bm-ups__h">¿Otro igual? <span>Uno para cada día y sumas para el −' + pct + ' %</span></p>' +
        '<div class="bm-ups__row"><img src="' + esc(img(line.image, 120)) + '" alt="" width="44" height="55" loading="lazy">' +
        '<span class="bm-ups__t"><b>' + esc(short(line.product_title)) + '</b><small>' + esc(nice(line.variant_title || '')) + ' · ' + fmt(line.final_price) + '</small></span>' +
        '<button type="button" class="bm-ups__plus" data-bm-plus="' + esc(line.key) + '" data-q="' + line.quantity + '">+1 igual</button></div></div>';
    }
    if (list.length) {
      h += '<p class="bm-ups__h">Combina con</p><div class="bm-ups__cards">' + list.map(function (p) {
        return '<a class="bm-ups__card" href="' + esc(p.url) + '"><img src="' + esc(img(p.featured_image, 300)) + '" alt="' + esc(short(p.title)) + '" loading="lazy"><span>' + esc(short(p.title)) + '</span><b>' + fmt(p.price) + '</b><u>Elegir talla</u></a>';
      }).join('') + '</div>';
    }
    box.innerHTML = h;
    box.hidden = !h;
  }
  function fill(box) {
    var pids = (box.getAttribute('data-pids') || '').split(',').filter(Boolean);
    if (!pids.length) { box.innerHTML = ''; box.hidden = true; return; }
    var key = [box.getAttribute('data-pids'), box.getAttribute('data-total'), box.getAttribute('data-count')].join('|');
    if (box.getAttribute('data-k') === key && box.firstChild) return;
    box.setAttribute('data-k', key);
    Promise.all([fetch('/cart.js').then(function (r) { return r.json(); }), recs(pids)]).then(function (res) {
      if (box.getAttribute('data-k') !== key) return;
      var cart = res[0], inCart = {};
      cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
      render(box, cart, res[1].filter(function (p) { return !inCart[p.id]; }).slice(0, 3));
    }).catch(function () {});
  }
  function scan() { document.querySelectorAll('[data-bm-ups]').forEach(fill); }
  function plus(btn) {
    btn.disabled = true; btn.textContent = '…';
    fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: btn.getAttribute('data-bm-plus'), quantity: (+btn.getAttribute('data-q') || 1) + 1 }) })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        btn.textContent = '✓ Añadido';
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'bm-ups', data: { itemCount: cart.item_count, source: 'bm-ups' } } }));
        if (!document.querySelector('cart-drawer-component dialog[open]')) setTimeout(function () { location.reload(); }, 400);
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Reintentar'; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bm-plus]');
    if (b) { e.preventDefault(); plus(b); }
  });
  var timer = null;
  function init() {
    scan();
    new MutationObserver(function () { if (timer) return; timer = setTimeout(function () { timer = null; scan(); }, 150); })
      .observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-total', 'data-pids', 'data-count', 'open'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
